import { render, staticRenderFns } from "./FormDetails.vue?vue&type=template&id=b6178cf8&scoped=true"
import script from "./FormDetails.vue?vue&type=script&lang=js"
export * from "./FormDetails.vue?vue&type=script&lang=js"
import style0 from "./FormDetails.vue?vue&type=style&index=0&id=b6178cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6178cf8",
  null
  
)

export default component.exports